<template>
  <div class="home">
    <Header :title="title" :showBack="true"></Header>
    <!-- 查询框 -->
    <van-search
      v-model="inputValue"
      :placeholder="queryTips"
      show-action
      clearable
      shape="round"
      @search="onSearchInfo"
    >
      <div slot="label" @click="showVehicleorDriver=true">{{query}}</div>
      <div slot="action" @click="onSearchInfo">查询</div>
    </van-search>

    <!-- 公司车辆查询结果列表 -->
    <div class="VehicleInfoList" v-if="vehicleList.length>0" ref="wrapper">
      <div>
        <div v-for="vehicle of vehicleList" :key="vehicle.GID" class="wrap">
          <div v-cloak class="vehicleNo">车牌号码：{{ vehicle.VehicleNo }}</div>
          <div v-cloak>
            <span>
              车牌颜色：
              <span>{{ vehicle.CodeName }}</span>
            </span>
            <span>
              审验有效期：
              <span>{{ vehicle.ShenYanYouXiaoQi }}</span>
            </span>
          </div>
          <div v-cloak>
            <span>
              核定座位数：
              <span>{{ vehicle.ApprovedSeatCount }}</span>
            </span>
            <span>
              载客座位数：
              <span>{{ vehicle.PassengerSeatCount }}</span>
            </span>
          </div>
          <div>
            <span>
              道路运输证号：
              <span>{{ vehicle.DaoLuYunShuZhengHao }}</span>
            </span>
            <span>
              运输类别：
              <span>{{ vehicle.TransportCategory }}</span>
            </span>
          </div>
          <div>
            <span>
              发动机号：
              <span>{{ vehicle.EngineNumber }}</span>
            </span>
            <span>
              车架号：
              <span>{{ vehicle.FrameNumber }}</span>
            </span>
          </div>
          <div>
            <span>
              是否有运力协议:
              <span>
                <van-tag type="success" v-if="vehicle.IsThereCapacityAgreement">✔</van-tag>
                <van-tag type="danger" v-else>✖</van-tag>
              </span>
            </span>
            <span>
              是否有合同第二页:
              <span>
                <van-tag type="success" v-if="vehicle.IsThereContracPage">✔</van-tag>
                <van-tag type="danger" v-else>✖</van-tag>
              </span>
            </span>
          </div>
          <div>
            <span>
              经营范围:
              <span>{{vehicle.JingYingFanWei}}</span>
            </span>
          </div>
          <div>
            <span>
              业户单位:
              <span>{{vehicle.BusinessUnit}}</span>
            </span>
          </div>
          <div>
            <span>
              厂牌型号：
              <span>{{ vehicle.ChangPai_XingHao }}</span>
            </span>
          </div>
          <div>
            <span>
              备注：
              <span>{{ vehicle.Remark }}</span>
            </span>
          </div>
          <div class="btnWrap">
            <span @click="onDeleteVehicle(vehicle)" class="copyClass">删除车辆</span>
            <span @click="onUpdateVehicle(vehicle)" class="modifyClass">修改车辆信息</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司司机查询结果列表 -->
    <div class="VehicleInfoList" v-if="dirverList.length>0">
      <div>
        <div v-for="driver of dirverList" :key="driver.GID" class="wrap">
          <div v-cloak class="vehicleNo">司机姓名：{{ driver.DriverName }}</div>
          <div v-cloak>
            <span>
              手机号码：
              <span>{{ driver.DriverTel }}</span>
            </span>
          </div>
           <div v-cloak>
            <span>
              身份证号码：
              <span>{{ driver.DriverCertNo }}</span>
            </span>
          </div>
          <div v-cloak>
            <span>
              从业资格证号码：
              <span>{{ driver.IndustryCertNo }}</span>
            </span>
          </div>
          <div v-cloak>
            <span>
              备注：
              <span>{{ driver.Remark }}</span>
            </span>
          </div>
          <div class="btnWrap">
            <span @click="onDeleteDriver(driver)" class="copyClass">删除司机</span>
            <span @click="onUpdateDriver(driver)" class="modifyClass">修改司机信息</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 资质查询结果显示  -->
    <div class="VehicleInfoList" v-if="conwinVehicleInfo" style="text-align: left;padding:0;">
      <van-collapse v-model="activeInfoNames">
        <van-collapse-item
          :title="item.TypeName"
          :name="item.TypeName"
          v-for="(item,i) in conwinVehicleInfo"
          :key="i"
        >
          <div class="clearfix" v-for="(info,j) in item.Item" :key="j">
            <div class="left_title">{{info.ItemName}}</div>
            <div class="right_content">{{info.ItemValue}}</div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <!-- 查询模式选择 -->
    <van-popup v-model="showVehicleorDriver" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showVehicleorDriver = false"
        @confirm="onCheckVehicleorDriver"
      />
    </van-popup>

    <!-- 新增车辆 司机 按钮 -->
    <div class="footBtn">
      <van-row>
        <van-col span="12">
          <van-button type="default" block @click="goAddVehicle">新增车辆</van-button>
        </van-col>
        <van-col span="12">
          <van-button type="default" block @click="goAddDriver">新增司机</van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header
  },
  data() {
    return {
      title: "车辆司机管理查询",
      columns: [{ text: "资质" }, { text: "车辆" }, { text: "司机" }],
      activeInfoNames: ["车辆信息"], //资质信息默认展开车辆信息
      queryTips: "请输入车牌号码",
      showVehicleorDriver: false, //是否显示选择车辆司机
      query: "资质", //查询模式
      inputValue: "", //查询字段
      conwinVehicleInfo: null, //车辆资质信息
      vehicleList: [], //车辆查询结果
      dirverList: [] //司机查询结果
    };
  },
  methods: {
    //新增司机
    goAddDriver() {
      this.$router.push({
        name: "DriverInfo"
      });
    },
    //新增车辆
    goAddVehicle() {
      this.$router.push({
        name: "VehicleInfo"
      });
    },
    //更新司机信息
    onUpdateDriver(driver) {
      this.$router.push({
        name: "DriverInfo",
        query: {
          GID: driver.GID
        }
      });
    },
    //删除司机
    onDeleteDriver(driver) {
      this.$dialog
        .confirm({
          title: "操作确认",
          message: "确定要删除司机: " + driver.DriverName + " 吗？"
        })
        .then(() => {
          let params = {
            _JsonText: JSON.stringify({
              GID: driver.GID,
              ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                .GID,
              ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserCode,
              ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserName
            })
          };
          this.$http
            .post(this.$api.onDeleteDriver, this.$qs.stringify(params))
            .then(res => {
              if (res.success) {
                this.$toast("删除司机成功");
                this.onSearchInfo();
                return;
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //修改车辆信息
    onUpdateVehicle(vehicle) {
      this.$router.push({
        name: "VehicleInfo",
        query: {
          GID: vehicle.GID
        }
      });
    },
    //删除车辆
    onDeleteVehicle(vehicle) {
      this.$dialog
        .confirm({
          title: "操作确认",
          message: "确定要删除车辆: " + vehicle.VehicleNo + " 吗？"
        })
        .then(() => {
          //删除车辆
          let params = {
            _JsonText: JSON.stringify({
              GID: vehicle.GID,
              ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                .GID,
              ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserCode,
              ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserName
            })
          };
          this.$http
            .post(this.$api.onDeleteVehicle, this.$qs.stringify(params))
            .then(res => {
              if (res.success) {
                this.$toast("删除车辆成功");
                this.onSearchInfo();
                return;
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //选择搜索车辆 或 司机
    onCheckVehicleorDriver(value) {
      this.query = value.text;
      if (this.query == "司机") {
        this.queryTips = "请输入司机号码或姓名";
      } else {
        this.queryTips = "请输入车牌号码";
      }
      this.showVehicleorDriver = false;
    },
    //查询
    onSearchInfo() {
      this.conwinVehicleInfo = null;
      this.vehicleList = [];
      if (!this.inputValue) {
        this.$toast("未输入需要查询的关键词");
        return;
      }
      if (this.query == "车辆") {
        //车辆查询
        let params = {
          CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
          VehicleNo: this.inputValue,
          sort: "VehicleNo"
        };
        this.$http
          .post(this.$api.onCompVehicleQuery, this.$qs.stringify(params))
          .then(res => {
            if (res.success) {
              this.vehicleList = res.data;
            }
          });
      } else if (this.query == "司机") {
        //司机查询
        let params = {
          CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
          DriverNameOrTel: this.inputValue
        };
        this.$http
          .post(this.$api.onCompDriverQuery, this.$qs.stringify(params))
          .then(res => {
            if (res.success) {
              this.dirverList = res.data;
            }
          });
      } else {
        //资质查询 1.校验车牌号是否正确
        let isVehiscleNo = this.$utils.isCarNo(this.inputValue);
        if (!isVehiscleNo) {
          this.$toast("请输入正确的车牌号码");
          return;
        }
        //2.判断车牌颜色  长度为7 为黄色大巴 超过7为绿色新能源车 暂无蓝色车录入
        let color = "黄色";
        if (this.inputValue.length > 7) {
          color = "绿色";
        }
        //3.调用接口查询
        let params = {
          ChePaiHao: this.inputValue,
          ChePaiYanSe: color,
          SearchType:"VehicleInfo"
          //CharteredBusEndTIme: this.$moment().format("YYYY-MM-DD"),
          //CharterContractCategory: "非节假日包车合同"
        };
        this.$http
          .post(this.$api.API_getVehicleInfo, this.$qs.stringify(params))
          .then(res => {
            if (res.success) {
              this.conwinVehicleInfo = [];
              res.data.forEach((item, i) => {
                if (i == 0) {
                  this.conwinVehicleInfo.push({
                    TypeName: item.TypeName,
                    Item: []
                  });
                } else {
                  if (item.TypeName != res.data[i - 1].TypeName) {
                    this.conwinVehicleInfo.push({
                      TypeName: item.TypeName,
                      Item: []
                    });
                  }
                }
                this.conwinVehicleInfo.forEach(info => {
                  if (info.TypeName == item.TypeName) {
                    info.Item.push({
                      ItemName: item.ItemName,
                      ItemValue: item.ItemValue
                    });
                  }
                });
              });
            }
          });
      }
    }
  },
  mounted: function() {},
  created() {
    if (this.$route.params.vehicleNo) {
      this.query = "车辆";
      this.inputValue = this.$route.params.vehicleNo;
      this.onSearchInfo();
    }
    if (this.$route.params.driverTel) {
      this.query = "司机";
      this.inputValue = this.$route.params.driverTel;
      this.onSearchInfo();
    }
  }
};
</script>

<style scoped lang="less">
.footBtn {
  position: absolute;
  width: 100%;
  bottom: 0rem;
}
.left_title {
  width: 30%;
  float: left;
}
.right_content {
  float: right;
  width: 70%;
  color: #323233;
  font-weight: bold;
}
.ModifyVehicle {
  width: 100%;
}
.VehicleInfoList {
  width: 100%;
  height: calc(100vh - 4.4rem);
  color: #666;
  font-weight: 700;
  padding: 0 0.4rem;
  box-sizing: border-box;
  overflow: scroll;
  position: absolute;
  top: 3rem;
  left: 0;
  right: 0;
  bottom: 1rem;
  > div {
    > .wrap {
      width: 100%;
      height: auto;
      font-size: 0.32rem;
      background-color: #fff;
      border-radius: 0.1rem;
      overflow: hidden;
      margin-top: 0.5rem;
      > .vehicleNo {
        height: 1rem;
        line-height: 1rem;
        background-color: #999;
        color: #e3f308;
        box-sizing: border-box;
        padding: 0 0.2rem;
      }
      > .btnWrap {
        width: 100%;
        height: auto;
        text-align: center;
        display: flex;
        justify-content: space-between;
        > span {
          flex: 1;
          background-color: #2891e7;
          color: #fff;
          text-align: center;
        }
      }
      > div {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        > span {
          flex: 1;
          height: auto;
          line-height: 1rem;
          border: 1px solid #ccc;
          box-sizing: border-box;
          padding: 0 0.2rem;
          text-align: left;
          > span {
            color: #2891e7;
          }
          > span.currentState {
            color: red;
          }
        }
        > span:nth-child(2) {
          border-left: 0;
        }
      }
    }
  }
}
</style>
